import { moduleProviderFactory } from 'core/providers';
import { ApplicationSettingList } from 'application/application-setting/pages';

(function () {
    moduleProviderFactory.application.register({
        routes: [
            {
                name: 'master.app.main.application-setting',
                pattern: '/application-settings',
                children: [
                    {
                        name: 'master.app.main.application-setting.list',
                        pattern: '',
                        tabTitle: 'APPLICATION_SETTING.LIST.TITLE',
                        component: ApplicationSettingList,
                        authorization: 'administrationSection.read',
                        data: {
                            title: 'APPLICATION_SETTING.LIST.TITLE'
                        }
                    }            
                ]
            }
        ],
        menu: [
            {
                title: 'MENU.ADMINISTRATION',
                order: 10,
                icon: 'users',
                authorization: 'administrationSection.read',
                subMenu: [
                    {
                        title: 'MENU.SETTINGS',
                        route: 'master.app.main.application-setting.list',
                        order: 5,
                        authorization: 'administrationSection.read',
                    }
                ]
            }
        ]
    });
})();
